const { default: vars } = require("../helpers");

const $preloader = $('.preloader');
const $percent = $preloader.find('.preloader__percent');
const $progress = $preloader.find('.preloader__progress');

const debug = false;
const animationDuration = 1;
const timeoutDelay = 30; // seconds

let filesLoaded = 0;
let filesTotal = 0;

let tweenPercent = null;
let tweenProgress = null;
let preloaderResize = false;

const setTotalFilesCount = () => {
	filesTotal += document.images.length;
	filesTotal += document.querySelectorAll('video, audio').length;
	filesTotal += 1; // window load
};

const getFilesToLoad = () => {
	return {
		images: [...document.images],
		media: [...document.querySelectorAll('video, audio')],
	};
};

const animatePercent = (percent) => {
	return new Promise((resolve) => {
		const progress = {
			value: $percent.text(),
		};

		if (tweenPercent !== null) {
			tweenPercent.kill();
			tweenPercent.vars.onComplete();
		}

		tweenPercent = gsap.to(progress, {
			onComplete: resolve,
			onUpdate() {
				$percent.text(progress.value);
			},
			roundProps: 'value',
			duration: animationDuration,
			value: percent,
		});
	});
};

const animateProgress = (percent) => {
	return new Promise((resolve) => {
		if (tweenProgress !== null) {
			tweenProgress.kill();
			tweenProgress.vars.onComplete();
		}

		tweenProgress = gsap.to($progress, {
			onComplete: resolve,
			duration: animationDuration,
			width: `${percent}%`,
		});
	});
};

const setProgress = () => {
	const percent = filesLoaded / filesTotal * 100;

	return Promise.all([animatePercent(percent), animateProgress(percent)]);
};

const loadComplete = async (resolve) => {
	filesLoaded++;

	await setProgress();

	resolve();
};

const loadPage = () => {
	return new Promise((resolve) => {
		if (document.readyState === 'complete') {
			loadComplete(resolve);

			return;
		}

		window.addEventListener('load', () => {
			loadComplete(resolve);
		}, {once: true});
	});
};

const loadImage = (src) => {
	return new Promise((resolve) => {
		const image = new Image();
		const onload = () => {
			loadComplete(resolve);
		};

		image.onload = onload;
		image.onerror = onload;
		image.src = src;
	});
};

const loadMedia = (media) => {
	return new Promise((resolve) => {
		const newMedia = media.nodeName === 'VIDEO' ? document.createElement('video') : new Audio();
		const onload = () => {
			loadComplete(resolve);

			document.body.removeChild(newMedia);
		};

		newMedia.oncanplaythrough = onload;
		newMedia.onerror = onload;
		newMedia.src = media.currentSrc;

		document.body.appendChild(newMedia);

		newMedia.setAttribute('style', 'position: absolute; left: -9999px; top: 0; z-index: -9999; width: 0; height: 0; opacity: 0; visibility: hidden;');
		newMedia.load();
	});
};

const loadAll = (files) => {
	const array = [];

	array.push(
		loadPage(),
		...files.images.map((image) => loadImage(image.src)),
		...files.media.map((media) => loadMedia(media)),
	);

	return Promise.all(array);
};

const finish = () => {
	$preloader.addClass('is-finished');

	gsap.to($preloader, {
		onComplete() {
			$preloader
				.addClass('is-hidden')
				.removeClass('is-animating is-finished');
		},
		delay: animationDuration / 2,
		clearProps: 'all',
		autoAlpha: 0,
	});
};

const start = () => {
	$preloader.addClass('is-animating');
};

const delay = () => {
	return new Promise((resolve) => {
		setTimeout(resolve, 500);
	});
};

const timeout = () => {
	setTimeout(() => {
		if ($preloader.hasClass('is-finished') || $preloader.hasClass('is-hidden')) {
			return;
		}

		finish();
	}, timeoutDelay * 1000);
};

const init = async () => {
	if (debug) {
		$preloader.addClass('is-hidden');

		return;
	}

	if (vars.isMobile() && vars.$window.width() < vars.$window.height()) {
		vars.$window.on('resize', () => {
			if (preloaderResize) {
				init();

				preloaderResize = false;
			}
		})

		preloaderResize = true;

		return;
	}


	setTotalFilesCount();
	start();
	timeout();

	await loadAll(getFilesToLoad());
	await delay();

	finish();
};

init();